import { Button, Divider, Paper, Stack } from "@mui/material";
import { CustomProgressBar, CustomText } from "components";
import Layout from "layouts";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  curYearNum,
  formatArray,
  getDayName,
  getWeekDaysByWeekNumber,
} from "utility";
import { DispatchHeader } from "../DispatchHeader";
import { OrderTable } from "./OrderTable";

export function DayOrders() {
  const history = useNavigate();
  const {
    selWeek = {},
    selDay = 0,
    boxes = [],
    selYear,
  } = useSelector((state) => state?.app ?? {});

  const handleClickDispatch = () => {
    history("/order-overview");
  };
  const completedBoxes = boxes?.filter((item) =>
    Boolean(item?.trackingInfo?.consignmentId)
  );
  return (
    <Layout sidebar={false} noHeader={true}>
      <div>
        <DispatchHeader
          backButton={true}
          title={getWeekDaysByWeekNumber({
            weekNumber: selWeek?.id,
            addDay: selDay,
            format: "dddd DD MMMM",
            yearNumber: selYear,
          })}
        />
        <Paper className={`flex my-2 cursor-pointer`}>
          <div className="border-r border-white-gray w-1/5 flex flex-col justify-center pl-4">
            <CustomText className="p-1" color="secondary" variant="body2">
              {getWeekDaysByWeekNumber({
                weekNumber: selWeek?.id,
                addDay: selDay,
                format: "Do of MMMM",
                yearNumber: curYearNum,
              })}
            </CustomText>
            <CustomText className="p-1" color="secondary" variant="h5" bold>
              {getDayName(selDay + 1)}
            </CustomText>
          </div>
          <Stack
            className="p-4 flex-1"
            direction="row"
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            <div className="w-1/3">
              <CustomText className="p-1" color="secondary" variant="body2">
                Number of boxes:
              </CustomText>
              <CustomText className="p-1" color="secondary" variant="h5" bold>
                {`${completedBoxes?.length} / ${formatArray(boxes).length}`}
              </CustomText>
            </div>
            <div className="w-2/3 flex flex-col justify-between">
              <CustomText className="p-1" color="secondary" variant="body2">
                Percentage fulfilled:
              </CustomText>
              <div className="flex items-center">
                <div className="flex-1">
                  <CustomProgressBar
                    variant="determinate"
                    value={(completedBoxes?.length / boxes.length) * 100}
                    height={10}
                  />
                </div>
                <CustomText className="pl-2" color="secondary">
                  {boxes?.length === 0
                    ? "0%"
                    : `${(completedBoxes?.length / boxes.length) * 100}%`}
                </CustomText>
              </div>
            </div>
          </Stack>
        </Paper>
        <div className="w-full py-2">
          <Button
            className="w-full"
            size="large"
            variant="contained"
            color="success"
            onClick={handleClickDispatch}
            disabled={!Boolean(formatArray(boxes).length)}
          >
            <span className="text-2xl py-3">START DISPATCH</span>
          </Button>
        </div>
        <div className="py-4">
          <OrderTable data={boxes} />
        </div>
      </div>
    </Layout>
  );
}
